import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  MapPin,
  Mail,
  Phone,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Youtube,
  Send,
} from "lucide-react";

import toast from "react-hot-toast";
import api from "../api/api";
import { navigation } from "../mock";

const LOGO = "/assets/images/favicon.png";
const ARISE_LOGO = "/assets/images/arise.jpeg";

const EMAILS = [
  "info@subeb.ak.gov.ng",
  "mails@subeb.ak.gov.ng",
  "techsupport@subeb.ak.gov.ng",
];

const PHONE = "07025328036";

const ADDRESS = "Idongesit Nkanga Secretariat, Uyo, Akwa Ibom State";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) return;

    try {
      setLoading(true);

      await api.post("/newsletter/subscribe", {
        name,
        email,
        honeypot,
      });

      setSubscribed(true);
      setEmail("");
      setName("");
      setHoneypot("");

      toast.success("Thank you for subscribing!");

      setTimeout(() => {
        setSubscribed(false);
      }, 3000);
    } catch (error) {
      toast.error(
        error?.response?.data?.detail ||
          error?.cleanMessage ||
          "Subscription failed"
      );
    } finally {
      setLoading(false);
    }
  };

  const updatedNavigation = navigation.filter((n) => n.path !== "/blog");

  return (
    <footer className="bg-[#06183f] text-slate-300 overflow-hidden">
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-center gap-4 text-center">
          <div className="flex items-center justify-center gap-4">
            <img
              src={LOGO}
              alt="Akwa Ibom State Universal Basic Education Board"
              className="w-[72px] h-[72px] object-contain"
            />

            <span className="h-[58px] w-[1.5px] bg-[#0b6b1d]" />

            <img
              src={ARISE_LOGO}
              alt="ARISE"
              className="w-[72px] h-[72px] object-contain"
            />
          </div>

          <h2 className="text-2xl md:text-4xl font-black tracking-[-1px] text-white leading-tight">
            Akwa Ibom State Universal Basic Education Board
          </h2>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <h3 className="text-white font-bold text-lg mb-5 relative pb-3 after:absolute after:left-0 after:bottom-0 after:w-10 after:h-0.5 after:bg-[#1f9d4c]">
            About AKSUBEB
          </h3>

          <p className="text-sm leading-relaxed mb-5">
            The Akwa Ibom State Universal Basic Education Board promotes
            uniform, qualitative and functional basic education for every child
            of school age across the 31 LGAs of Akwa Ibom State.
          </p>

          <div className="flex gap-2">
            <a
              href="https://web.facebook.com/aksubeb"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="AKSUBEB Facebook"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#ff6b00] flex items-center justify-center transition-colors"
            >
              <Facebook size={16} />
            </a>

            <a
              href="https://www.linkedin.com/company/aksubeb/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="AKSUBEB LinkedIn"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#ff6b00] flex items-center justify-center transition-colors"
            >
              <Linkedin size={16} />
            </a>

            <a
              href="#"
              aria-label="Twitter"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#ff6b00] flex items-center justify-center transition-colors"
            >
              <Twitter size={16} />
            </a>

            <a
              href="#"
              aria-label="Instagram"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#ff6b00] flex items-center justify-center transition-colors"
            >
              <Instagram size={16} />
            </a>

            <a
              href="#"
              aria-label="YouTube"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#ff6b00] flex items-center justify-center transition-colors"
            >
              <Youtube size={16} />
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-white font-bold text-lg mb-5 relative pb-3 after:absolute after:left-0 after:bottom-0 after:w-10 after:h-0.5 after:bg-[#1f9d4c]">
            Menus
          </h3>

          <ul className="space-y-2.5 text-sm">
            {updatedNavigation.map((n) => (
              <li key={n.label}>
                <Link
                  to={n.path}
                  className="hover:text-[#ff6b00] transition-colors flex items-center gap-2 before:content-['›'] before:text-[#0b6b1d]"
                >
                  {n.label}
                </Link>
              </li>
            ))}

            <li>
              <Link
                to="/blog"
                className="hover:text-[#ff6b00] transition-colors flex items-center gap-2 before:content-['›'] before:text-[#0b6b1d]"
              >
                News
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="uppercase text-xs tracking-widest text-[#0b6b1d] mb-2">
            Office Location
          </p>

          <h3 className="text-white font-bold text-lg mb-5">
            Contact us today!
          </h3>

          <p className="text-sm font-bold text-white mb-3">Head Office</p>

          <ul className="space-y-3 text-sm">
            <li className="flex gap-3">
              <MapPin
                size={16}
                className="flex-shrink-0 mt-0.5 text-[#0b6b1d]"
              />

              <span>{ADDRESS}</span>
            </li>

            {EMAILS.map((mail) => (
              <li key={mail} className="flex gap-3">
                <Mail
                  size={16}
                  className="flex-shrink-0 mt-0.5 text-[#0b6b1d]"
                />

                <a
                  href={`mailto:${mail}`}
                  className="hover:text-[#ff6b00] transition-colors break-all"
                >
                  {mail}
                </a>
              </li>
            ))}

            <li className="flex gap-3">
              <Phone
                size={16}
                className="flex-shrink-0 mt-0.5 text-[#0b6b1d]"
              />

              <a
                href={`tel:${PHONE}`}
                className="hover:text-[#ff6b00] transition-colors"
              >
                {PHONE}
              </a>
            </li>

            <li className="flex gap-3">
              <Phone
                size={16}
                className="flex-shrink-0 mt-0.5 text-[#ff6b00]"
              />

              <a
                href="tel:+2348090243111"
                className="hover:text-[#ff6b00] transition-colors"
              >
                Tech Support: +2348090243111
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-bold text-lg mb-5 relative pb-3 after:absolute after:left-0 after:bottom-0 after:w-10 after:h-0.5 after:bg-[#1f9d4c]">
            Newsletter
          </h3>

          <p className="text-sm leading-relaxed mb-4">
            Subscribe to our newsletter to get the latest updates from AKSUBEB
            straight to your inbox.
          </p>

          <form onSubmit={handleSubscribe} className="space-y-3 mb-8">
            <input
              type="text"
              value={honeypot}
              onChange={(e) => setHoneypot(e.target.value)}
              className="hidden"
              autoComplete="off"
              tabIndex="-1"
            />

            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              className="w-full px-4 py-3 bg-white/10 border border-white/20 text-white placeholder:text-slate-400 focus:outline-none focus:border-[#1f9d4c] text-sm"
            />

            <div className="flex">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 text-white placeholder:text-slate-400 focus:outline-none focus:border-[#1f9d4c] text-sm"
              />

              <button
                type="submit"
                disabled={loading}
                className="px-4 bg-[#ff6b00] hover:bg-[#1f9d4c] text-white transition-colors disabled:opacity-60"
              >
                <Send size={18} />
              </button>
            </div>
          </form>

          {subscribed && (
            <p className="text-[#0b6b1d] text-xs mb-6">
              ✓ Thank you for subscribing!
            </p>
          )}
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col lg:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p className="text-center lg:text-left">
            ©️ 2026 AKSUBEB | All Rights Reserved I Site by{" "}
            <a
              href="https://akwaibomtimes.ng/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#ff6b00] hover:text-[#1f9d4c] transition-colors font-semibold"
            >
              AkwaIbomTimes Media & Communication Ltd
            </a>
          </p>

          <div className="flex flex-wrap items-center justify-center lg:justify-end gap-x-4 gap-y-2">
            <a
              href="https://akwaibomstate.gov.ng/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#ff6b00] transition-colors"
            >
              AKSG
            </a>

            <a
              href="https://ubec.gov.ng/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#ff6b00] transition-colors"
            >
              UBEC
            </a>

            <Link
              to="/admin-signin"
              className="hover:text-[#ff6b00] transition-colors"
            >
              Admin Login
            </Link>

            <Link
              to="/staff-mail"
              className="hover:text-[#ff6b00] transition-colors"
            >
              Staff Email
            </Link>

            <Link
              to="/privacy"
              className="hover:text-[#ff6b00] transition-colors"
            >
              Privacy
            </Link>

            <Link
              to="/terms"
              className="hover:text-[#ff6b00] transition-colors"
            >
              Site Terms
            </Link>

            <Link
              to="/disclaimer"
              className="hover:text-[#ff6b00] transition-colors"
            >
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;